import { Badge, Button } from "@material-tailwind/react";

export function BadgeDot() {
  return (
    <Badge>
      <Button>Settings</Button>
    </Badge>
  );
}
